import React from 'react';
import Bem from '../../../../lib/bemUtils/bem';

type AbbrProps = {
  text: string;
  title: string;
};
export function DownloadAbbr({ text, title }: AbbrProps) {
  return (
    <abbr className={Bem('download__abbr')} title={title}>
      {text}
    </abbr>
  );
}
